// extracted by mini-css-extract-plugin
export default {"avatar":"_1F8_BSUC_OjVgds5RUGWbB","avatarBackground":"_24nBXK4D4pexCaXQ6B_0ir","avatarChar":"_3Z4ZhD_KDy3WmI-7qu5PZR"};